import { ProductItem } from '@app-model/response';
import { v4 as uuid } from 'uuid';

import { Field } from '../form/field';

export class CartItem {
  product: ProductItem;
  key: string;
  valid: boolean;
  message: string;
  customerTaxForm: Field[];
  dealerTaxForm: Field[];
  customerTaxValues: {};
  warning: Warning[];
  containsWarning: boolean;
  code: string;
  errorType: string;

  constructor(product: ProductItem) {
    this.product = product;
    this.valid = true;
    this.customerTaxForm = [];
    this.dealerTaxForm = [];
    this.key = uuid();
    this.message = '';
    this.code = '';
    this.errorType = '';
    this.customerTaxValues = {};
  }
}

export class Warning {
  code: string;
  message: string;
}
